<script>
import { layoutMethods, layoutComputed, auditSpaceMethods, auditSpaceComputed } from "@/state/helpers"
import storeHistory from "@/views/pages/my-space/store-campaign-details-history.vue";
import storeAuditSpace from "@/views/pages/audit-space/store-audit-space.vue";
import GmapCustomMarker from 'vue2-gmap-custom-marker';

export default {
  page: {
    title: "My Space",
  },
  data() {
    return {
      businessId:0,
      campaignHdrId:0,
      isDisplay:false,
      pov: null,
      pano: null,
      mapOptions: {
        zoom: 20,
        zoomControl: true,
        mapTypeControl: true,
        scaleControl: false,
        streetViewControl: true,
        rotateControl: false,
        fullscreenControl: true,
        disableDefaultUi: false,
        minZoom: 1,
        maxZoom: 100
      },
    };
  },
  components: {
    storeHistory,
    storeAuditSpace,
    'gmap-custom-marker': GmapCustomMarker
  },
  computed: {
    ...layoutComputed,
    ...auditSpaceComputed,
    landmarks: {
      get(){
        if(this.auditStoreInfo.landmark){
          return this.auditStoreInfo.landmark.split(',').filter(str => str).join(', ');
        } else {
          return null;
        }
      }
    },
  },
  methods: {
    ...layoutMethods,
    ...auditSpaceMethods,
    async getStoreInfo(){
      var params= {"businessId":this.businessId,"campaignHdrId":this.campaignHdrId}
      console.log('><>><><><><> getStoreInfo',params);
      await this.fetchStoreInfo(params).then((res)=>{
        this.isDisplay=true;
        console.log(res)
        this.changeBreadCrumb({
          breadCrumbs: [
            { text: 'Audit Space', to: { name: 'audit-space'} },
            { text: this.auditStoreInfo.campaignName, to: { name: 'audit-space'} },
            { text: this.auditStoreInfo.storeName, to: { name: 'store-campaign-details'} }
          ],
        });
      });
    },
    updatePano(pano) {
      this.pano = pano;
    },
    updatePov(pov) {
      this.pov = pov;
    },
    openModal(modal=''){
      this.$bvModal.show(modal);
    },
    closeModal(modal=''){
      this.$bvModal.hide(modal);
    },
  },
  async mounted(){
    this.businessId = this.$route.params.id;
    this.campaignHdrId = this.$route.params.chid;
    await this.getStoreInfo();
    // this.$toast.showToast('success', "Successful test", "Your top-up was successfully added to you wallet.");
  }
};
</script>
<template>
  <div>
    <!-- {{ auditStoreInfo }}
    {{ auditStoreInfoSpaceRented }} -->
    <div class="row" v-if="isDisplay">
      <div class="col-md-8 col-sm-12">
        <b-card class="w-100 pt-0 pb-0 border-0">
          <div class="">
            <div style="position:relative;">
              <div>
                  <!-- style=""> -->
                  <!-- <gmap-street-view-panorama
                    style="width: 100px; height: 100px; position: absolute; z-index: 4; bottom: 40px; right: 20px; border:2px solid #fff"
                    :position="{ lat: 52.201272, lng: 0.11872 }"
                    :pov="pov"
                    :zoom="1"
                    @pano_changed="updatePano"
                    @pov_changed="updatePov"
                  ></gmap-street-view-panorama> -->
                  <!-- <iframe
                    v-if="auditStoreInfo.latitude != null && auditStoreInfo.longitude != null"
                    style="width: 100px; height: 100px; position: absolute; z-index: 4; bottom: 40px; right: 20px; border:2px solid #fff"
                    :src="`https://maps.google.com/maps?q=${this.auditStoreInfo.longitude}, ${this.auditStoreInfo.latitude}&z=14&amp;output=embed`"
                  >
                  </iframe> -->
                  <div v-if="auditStoreInfo.latitude != null && auditStoreInfo.longitude != null" @click="openModal('bv-modal-gmap')">
                    <gmap-map
                      :options="mapOptions"
                      :center="{lat:auditStoreInfo.latitude, lng:auditStoreInfo.longitude}"
                      style="width: 100px; height: 100px;position: absolute; z-index: 4; bottom: 40px; right: 20px; border:2px solid #fff"
                    >
                      <gmap-custom-marker :marker="{lat:auditStoreInfo.latitude, lng:auditStoreInfo.longitude}">
                        <img class="map-marker" src="@/assets/images/map_marker.png" />
                      </gmap-custom-marker>
                    </gmap-map>
                  </div>
                  <img v-else
                    style="width: 100px; height: 100px; position: absolute; z-index: 4; bottom: 40px; right: 20px; border:2px solid #fff"
                    :src="require('@/assets/images/img-placeholder.png')"
                    alt="Card image cap"
                  />
              </div>
              <img
                :src="auditStoreInfo.storePhoto"
                class="card-img-top rounded mb-4"
                alt="Card image cap"
                @error="
                  (e) =>
                    (e.target.src = require('@/assets/images/img-placeholder.png'))
                "
              />
            </div>
            <b-button class="me-2 mb-1 view-btn p-2" 
              variant="secondary" style="display: none;"
              @click="getStoreInfo">
              test api
            </b-button>
            <div class="d-flex justify-content-between">
              <div>
                <p class="store-name text-capitalize">{{auditStoreInfo.storeName}}</p>
              </div>
            </div>
            <p class="m-0 ts-14 mb-2">
              <i class="bx bx-store me-1"></i> <span class="ts-12">{{auditStoreInfo.businessType }}</span>
            </p>
            <p class="m-0 ts-14 mb-2">
              <i class="bx bx-calendar me-1"></i> <span class="ts-12">Upto {{auditStoreInfo.duration}}  months</span>
            </p>
            <p class="m-0 ts-14 mb-2">
              <i class="bx bx-user me-1"></i> <span class="ts-12">{{auditStoreInfo.fullName}}</span>
            </p>
            <p class="m-0 ts-14 mb-2">
              <i class="bx bx-mobile me-1"></i> <span class="ts-12">{{auditStoreInfo.mobileNumber}}</span>
            </p>
            <p class="m-0 ts-14 mb-2">
              <i class="bx bx-map me-1"></i> <span class="ts-12">{{auditStoreInfo.fullAddress}}</span>
            </p>
            <hr />
            <div class="ts-14">
              Nearby Landmark:  {{landmarks}} <br />
            </div>
            <hr />
            <b-modal id="bv-modal-gmap" title="Store Location" size="lg" hide-header hide-title hide-footer hide-header-close>
              <div class="ta-right">
                <span class="c-pointer " @click="closeModal('bv-modal-gmap')"><i class="bx bx-x"></i></span>
              </div>
              <div>
                <gmap-map
                  :options="mapOptions"
                  :center="{lat:auditStoreInfo.latitude, lng:auditStoreInfo.longitude}"
                  style="width: 100%; height: 500px"
                >
                  <gmap-custom-marker :marker="{lat:auditStoreInfo.latitude, lng:auditStoreInfo.longitude}">
                    <img class="map-marker" src="@/assets/images/map_marker.png" />
                  </gmap-custom-marker>
                </gmap-map>
              </div>

            </b-modal>
          </div><!--end div of store details-->
          <div>
            <store-audit-space/>
          </div>
        </b-card>
      </div>
      <div class="col-md-4 col-sm-12">
        <store-history/>
      </div>
    </div>
  </div>
</template>